import { ConnectFile, UserDetails } from 'trimble-connect-workspace-api';
import { ExternalFileId } from '../../../connect/models/external-file-id';

export enum ConnectTreeItemType {
  previous = 'previous',
  folder = 'folder',
  file = 'file',
}

export interface ConnectTreeItem {
  type: ConnectTreeItemType;
  regionUrl?: string;
  versionId?: string;
  externalFileId?: ExternalFileId;
  folderId?: string;
  id: string;
  name: string;
  size: number;
  modifiedBy?: string;
  modifiedOn?: Date;
  selected: boolean;
}

export interface ConnectFileDetail extends ConnectFile {
  size: number;
  modifiedOn: string;
  modifiedBy: Pick<UserDetails, 'id' | 'firstName' | 'lastName'>;
  createdBy: Pick<UserDetails, 'id' | 'firstName' | 'lastName'>;
}

export interface ConnectFileDownload {
  id: string;
  versionId: string;
  url: string;
}
